// (c) chaehongee. Confidential and proprietary.

import { http, buildApiUrl } from './http'
import type { NodeResponse } from 'models-ts/node'

export type NodeUploadType = 'image' | 'mask' | 'video'

export async function uploadNode(
    file: File,
    sessionId: string,
    type: NodeUploadType = 'image'
): Promise<NodeResponse> {
    const form = new FormData()
    form.append('file', file)
    form.append('session_id', sessionId)
    form.append('type', type)
    return http<NodeResponse>(buildApiUrl('/node/upload'), {
        method: 'POST',
        body: form,
    })
}

export async function importNodeFromUrl(
    url: string,
    sessionId: string,
    type: NodeUploadType = 'image'
): Promise<NodeResponse> {
    return http<NodeResponse>(buildApiUrl('/node/import'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ url, session_id: sessionId, type }),
    })
}

export async function getNode(nodeId: string): Promise<NodeResponse> {
    return http<NodeResponse>(buildApiUrl(`/node/${encodeURIComponent(nodeId)}`), {
        method: 'GET',
    })
}

export async function deleteNode(nodeId: string): Promise<void> {
    await http<void>(buildApiUrl(`/node/${encodeURIComponent(nodeId)}`), {
        method: 'DELETE',
    })
}

export async function updateNodeImage(
    nodeId: string,
    file: File
): Promise<NodeResponse> {
    const form = new FormData()
    form.append('file', file)
    return http<NodeResponse>(buildApiUrl(`/node/${encodeURIComponent(nodeId)}/image`), {
        method: 'PATCH',
        body: form,
    })
}
